import {
  Icon,
  Card,
  Input,
  Table,
  Button,
  message,
  Spin,
  Modal,
  Row,
  Col,
  notification,
  DatePicker,
  Tooltip,
  Select,
  Checkbox,
} from "antd";
import F from "../../../../Functions";
import { Link } from "react-router-dom";
import { Translate, Translator } from "react-translated";
import React, { useEffect, useState, useLocation, useCallback } from "react";
import moment from "moment";
import axios from "axios";
import Pagination from "../../../../components/pagination";
import {
  AGENCY_MANAGER,
  ALL_AGENCIES,
  ASC,
  DATE_FORMAT,
  DESC,
  EA,
  EXPORT_DATA,
  FOLLOWUP,
  LSP,
  PROSPECT,
  SORT_ORDER_ASCEND,
  SORT_ORDER_DESCEND,
  SUPER_ADMIN,
} from "../../../../utils/Constants";
import { useBoundStore } from "../../../../store/useBoundStore";
import {
  GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE,
  GET_AM_ASSOCIATED_AGENCIES,
  GET_AM_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID,
  GET_AO_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID,
  GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID,
} from "../../../../utils/Api_enums";
import { BodyDropPivotTarget } from "ag-grid-community";
import CustomAgGridTable from "../../../../Common-Table/CustomAgGridTable";
import CustomHeader from "../../../../CommonHeader/CustomHeader";
import "./EaAppointmentLogs.css";
import { set } from "lodash";
import { useRangePickerCloseButton } from "../../../../utils/rangePickerCloseButton";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const ButtonGroup = Button.Group;
// const dateFormat = "MM.DD.YYYY";
const dateFormat = DATE_FORMAT;
const GLOBAL_DASHBOARD_START_DATE = "2010-01-01";
const GLOBAL_DASHBOARD_END_DATE = "2050-01-01";

const { Option } = Select;

function EaAppointmentLogs(props) {
  const user = props.user;
  const { AMDashboardFilter, setAMDashboardFilter, setFsFilters } = useBoundStore();
  const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
  const fSfilters = useBoundStore.getState().fSfilters || {};
  const params = new URLSearchParams(props.location.search);
  const isFromAllViewAppointment = params.get("isFromAllViewAppointment");
  const isGlobalDashboard = props.isGlobalDashboard || params.has("global_dashboard");
  const [agencyStaffList, setAgencyStaffList] = useState([]);

  const years = Array.from({ length: 41 }, (_, i) => 2010 + i);
  const months = moment.months();
  const [open, setOpen] = useState(false);
  useRangePickerCloseButton(open, setOpen);


  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);

  const user_t =
    isFromAllViewAppointment === "true"
      ? user.id
      : localStorage.getItem("user_t") || "";
  const [user_type, set_user_type] = useState(localStorage.getItem("user_t") || "");
  const filter_lsp = localStorage.getItem("filter_lsp") || "";

  const reviewEaDash = localStorage.getItem("reviewEaDash") || 0;
  const vonboardEaDash = localStorage.getItem("vonboardEaDash") || 0;
  const leadEaDash = localStorage.getItem("leadEaDash") || 0;
  const opportunityEaDash = localStorage.getItem("opportunityEaDash") || 0;

  const [agency_id, setAgencyId] = useState(user.agency_id);
  const [search, setSearch] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const getInitialDates = () => {
    if (isGlobalDashboard) {
      return {
        start_date: GLOBAL_DASHBOARD_START_DATE,
        end_date: GLOBAL_DASHBOARD_END_DATE,
      };
    }

    const myDateObj = localStorage.getItem("dateObj");
    const parsedDateObj = myDateObj ? JSON.parse(myDateObj) : null;
    const globalDates = (useBoundStore.getState().GlobalDashboardFilter || {}).datemodified || {};

    if (user.user_type === SUPER_ADMIN && globalDates.start_date && globalDates.end_date) {
      return {
        start_date: moment(globalDates.start_date).format("YYYY-MM-DD"),
        end_date: moment(globalDates.end_date).format("YYYY-MM-DD"),
      };
    }

    return {
      //added due to new date filter implementation
      start_date: (AMDashboardFilter.datemodified && AMDashboardFilter.datemodified.start_date) || "2010-01-01",
      end_date: (AMDashboardFilter.datemodified && AMDashboardFilter.datemodified.end_date) ||
        (parsedDateObj && parsedDateObj.end_date) ||
        moment().format("YYYY-MM-DD")

      //commented due to old date filter implementation
      // start_date: (parsedDateObj && parsedDateObj.start_date) || "2010-01-01",
      // end_date: (parsedDateObj && parsedDateObj.end_date) || "2050-01-01",
    };
  };
  const {
    start_date: initialStartDate,
    end_date: initialEndDate,
  } = getInitialDates();
  const [start_date, setStartDate] = useState(initialStartDate);
  const [end_date, setEndDate] = useState(initialEndDate);
  const [loading, setLoading] = useState(true);
  const [lsp, setLsp] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState(
    AMDashboardFilter.agency_id
  );
  const [agencies, setAgencies] = useState([]);
  const [globalGridAgencies, setGlobalGridAgencies] = useState([]);
  const [globalGridFilteredAgencyResults, setGlobalGridFilteredAgencyResults] = useState([]);
  const [globalGridAgencyOptions, setGlobalGridAgencyOptions] = useState([]);
  const [gridSelectedCarriers, setGridSelectedCarriers] = useState(
    fSfilters.gridSelectedCarriers && fSfilters.gridSelectedCarriers.length > 0
      ? fSfilters.gridSelectedCarriers
      : (globalDashboardFilter.selectedCarriers || [])
  );
  const [gridSelectedAgencyState, setGridSelectedAgencyState] = useState(
    fSfilters.gridSelectedAgencyState && fSfilters.gridSelectedAgencyState.length > 0
      ? fSfilters.gridSelectedAgencyState
      : (globalDashboardFilter.selectedAgencyState || [])
  );
  const [gridSelectedAgencies, setGridSelectedAgencies] = useState(
    fSfilters.gridSelectedAgencies && fSfilters.gridSelectedAgencies.length > 0
      ? fSfilters.gridSelectedAgencies
      : ((globalDashboardFilter.selectedAgencies && globalDashboardFilter.selectedAgencies.length > 0)
        ? globalDashboardFilter.selectedAgencies
        : (globalDashboardFilter.agency_id ? [globalDashboardFilter.agency_id] : []))
  );
  const [bfiles, setBfiles] = useState({
    Review: {
      data: [],
      page: 1,
      total_pages: 0,
    },
    FollowUp: {
      data: [],
      page: 1,
      total_pages: 0,
    },
    Prospect: {
      data: [],
      page: 1,
      total_pages: 0,
    },
  });
  const { type_of_call_selected: type_of_call_selected_EA } = useBoundStore(
    (state) => ({
      type_of_call_selected: state.type_of_call_selected,
    })
  );

  const getDefaultSelection = () => {
    if (type_of_call_selected_EA) return type_of_call_selected_EA;
    if (reviewEaDash == 1) return "Review";
    // if (vonboardEaDash == 1) return "Prospect";
    if (leadEaDash == 1) return PROSPECT;
    if (opportunityEaDash == 1) return FOLLOWUP;
    return "Review";
  };

  const [type_of_call_selected, setSelectedCallType] = useState(
    getDefaultSelection
  );

  const type_of_call = ["Review", "Prospect", "FollowUp"];

  const getGlobalDashboardAgencyIdsForHistory = () => {
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const fS = useBoundStore.getState().fSfilters || {};
    const pageSelectedAgencies = fS.gridSelectedAgencies || [];
    const pageFilteredAgencyIds = fS.gridFilteredAgencyIds || [];
    const pageSelectedCarriers = fS.gridSelectedCarriers || [];
    const pageSelectedAgencyState = fS.gridSelectedAgencyState || [];
    const hasPageCarrierOrStateFilter =
      pageSelectedCarriers.length > 0 || pageSelectedAgencyState.length > 0;

    if (pageSelectedAgencies.length > 0) return pageSelectedAgencies;

    if (hasPageCarrierOrStateFilter) {
      return pageFilteredAgencyIds.length > 0 ? pageFilteredAgencyIds : [-1];
    }

    if (globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0) {
      return globalFilter.selectedAgencies;
    }

    if (globalFilter.agency_id) return [globalFilter.agency_id];

    if (
      (globalFilter.selectedCarriers && globalFilter.selectedCarriers.length > 0) ||
      (globalFilter.selectedAgencyState && globalFilter.selectedAgencyState.length > 0)
    ) {
      return globalFilter.filteredAgencyIds && globalFilter.filteredAgencyIds.length > 0
        ? globalFilter.filteredAgencyIds
        : [-1];
    }

    return [];
  };

  const getCarrierFilterValues = (selectedCarriers = gridSelectedCarriers) => {
    return selectedCarriers
      .map((selectedCarrier) => {
        const carrier = F.getCarriers().find((item) => item.id === selectedCarrier);
        return carrier ? carrier.name : selectedCarrier;
      })
      .filter((carrier) => carrier && carrier !== "All Carrier");
  };

  const getLocallyFilteredGlobalAgencies = (
    agenciesList = globalGridAgencies,
    selectedCarriers = gridSelectedCarriers,
    selectedAgencyState = gridSelectedAgencyState
  ) => {
    const carrierFilters = getCarrierFilterValues(selectedCarriers);
    const activeFilters = selectedAgencyState.map(String);

    return agenciesList.filter((agency) => {
      const carrierMatch =
        carrierFilters.length === 0 ||
        carrierFilters.includes(agency.agency_owner_carrier);
      const activeMatch =
        activeFilters.length === 0 ||
        activeFilters.includes(String(agency.active === 1));

      return carrierMatch && activeMatch;
    });
  };

  const getInitialGlobalAgencyOptions = (agenciesList, selectedAgencies = gridSelectedAgencies) => {
    const selectedIds = new Set(selectedAgencies || []);
    const selectedAgencyOptions = agenciesList.filter((agency) => selectedIds.has(agency.id));
    const firstAgencies = agenciesList.slice(0, 100);
    const optionMap = new Map();

    [...selectedAgencyOptions, ...firstAgencies].forEach((agency) => {
      optionMap.set(agency.id, agency);
    });

    return Array.from(optionMap.values());
  };

  const getGlobalAgencyDateRange = (selectedAgencyIds, agenciesList) => {
    if (isGlobalDashboard) {
      return {
        start_date: GLOBAL_DASHBOARD_START_DATE,
        end_date: GLOBAL_DASHBOARD_END_DATE,
      };
    }

    const selectedIds = new Set(selectedAgencyIds || []);
    const selectedAgencyList = agenciesList.filter((agency) => selectedIds.has(agency.id));
    const oldestAgency = F.getOldestAgency(selectedAgencyList.length > 0 ? selectedAgencyList : agenciesList);

    if (!oldestAgency) {
      const globalDates = (useBoundStore.getState().GlobalDashboardFilter || {}).datemodified || {};
      return {
        start_date: globalDates.start_date ? moment(globalDates.start_date).format("YYYY-MM-DD") : "2010-01-01",
        end_date: globalDates.end_date ? moment(globalDates.end_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      };
    }

    const startDate = moment(oldestAgency.start_date);
    const endDate = moment(oldestAgency.end_date || new Date());

    return {
      start_date: startDate.isValid() ? startDate.format("YYYY-MM-DD") : "2010-01-01",
      end_date: endDate.isValid() ? endDate.format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
    };
  };

  const applyGlobalGridAgencyFilters = ({
    selectedCarriers = gridSelectedCarriers,
    selectedAgencyState = gridSelectedAgencyState,
    selectedAgencies = gridSelectedAgencies,
    agenciesList = globalGridAgencies,
    shouldLoad = true,
  } = {}) => {
    const filteredAgencyResults = getLocallyFilteredGlobalAgencies(
      agenciesList,
      selectedCarriers,
      selectedAgencyState,
    );
    const validSelectedAgencies = (selectedAgencies || []).filter((agencyId) =>
      filteredAgencyResults.some((agency) => agency.id === agencyId)
    );
    const filteredAgencyIds = filteredAgencyResults.map((agency) => agency.id).filter(Boolean);
    const hasCarrierOrStateFilter = selectedCarriers.length > 0 || selectedAgencyState.length > 0;
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const globalDates = globalFilter.datemodified || {};
    const hasNoPageGridFilters =
      selectedCarriers.length === 0 &&
      selectedAgencyState.length === 0 &&
      validSelectedAgencies.length === 0;
    const updatedDateRange = isGlobalDashboard
      ? {
        start_date: GLOBAL_DASHBOARD_START_DATE,
        end_date: GLOBAL_DASHBOARD_END_DATE,
      }
      : hasNoPageGridFilters && globalDates.start_date && globalDates.end_date
      ? {
        start_date: moment(globalDates.start_date).format("YYYY-MM-DD"),
        end_date: moment(globalDates.end_date).format("YYYY-MM-DD"),
      }
      : getGlobalAgencyDateRange(validSelectedAgencies, filteredAgencyResults);

    setGlobalGridFilteredAgencyResults(filteredAgencyResults);
    setGlobalGridAgencyOptions(getInitialGlobalAgencyOptions(filteredAgencyResults, validSelectedAgencies));
    setGridSelectedCarriers(selectedCarriers);
    setGridSelectedAgencyState(selectedAgencyState);
    setGridSelectedAgencies(validSelectedAgencies);
    setStartDate(updatedDateRange.start_date);
    setEndDate(updatedDateRange.end_date);

    setFsFilters({
      gridSelectedCarriers: selectedCarriers,
      gridSelectedAgencyState: selectedAgencyState,
      gridSelectedAgencies: validSelectedAgencies,
      gridFilteredAgencyIds: hasCarrierOrStateFilter
        ? (filteredAgencyIds.length > 0 ? filteredAgencyIds : [-1])
        : [],
      datemodified: updatedDateRange,
      page: 1,
    });

    if (shouldLoad) {
      getHistoryGrid({
        from: updatedDateRange.start_date,
        to: updatedDateRange.end_date,
        page: 1,
      });
    }
  };

  //commented due to old date filter implementation
  // useEffect(() => {
  //   loadAppointmentLogs();
  // }, [user_type]);

  //add due to new date filter implementation

  useEffect(() => {
    if (!start_date || !end_date) return;

    loadAppointmentLogs();
  }, [start_date, end_date, agency_id, searchFilter, user_type]);

  useEffect(() => {
    if (user.user_type !== SUPER_ADMIN) return undefined;

    let isMounted = true;
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const fsFilter = useBoundStore.getState().fSfilters || {};
    const selectedCarriers = fsFilter.gridSelectedCarriers && fsFilter.gridSelectedCarriers.length > 0
      ? fsFilter.gridSelectedCarriers
      : (globalFilter.selectedCarriers || []);
    const selectedAgencyState = fsFilter.gridSelectedAgencyState && fsFilter.gridSelectedAgencyState.length > 0
      ? fsFilter.gridSelectedAgencyState
      : (globalFilter.selectedAgencyState || []);
    const selectedAgencies = fsFilter.gridSelectedAgencies && fsFilter.gridSelectedAgencies.length > 0
      ? fsFilter.gridSelectedAgencies
      : ((globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0)
        ? globalFilter.selectedAgencies
        : (globalFilter.agency_id ? [globalFilter.agency_id] : []));

    axios.get(GET_ALL_AGENCIES_BY_CARRIER_AND_ACTIVE)
      .then((res) => {
        if (!isMounted) return;
        const agenciesList = Array.isArray(res.data) ? res.data : [];
        setGlobalGridAgencies(agenciesList);
        applyGlobalGridAgencyFilters({
          selectedCarriers,
          selectedAgencyState,
          selectedAgencies,
          agenciesList,
          shouldLoad: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching global appointment history agencies:", error);
        if (!isMounted) return;
        setGlobalGridAgencies([]);
        setGlobalGridFilteredAgencyResults([]);
        setGlobalGridAgencyOptions([]);
      });

    return () => {
      isMounted = false;
      setFsFilters({
        gridSelectedCarriers: [],
        gridSelectedAgencyState: [],
        gridSelectedAgencies: [],
        gridFilteredAgencyIds: [],
      });
    };
  }, [user.user_type]);


  // useEffect(() => {
  //   const initDates = async () => {
  //     if (user.user_type === AGENCY_MANAGER) {
  //       try {
  //         const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${user.id}`);

  //         if (res.data && res.data.length > 0) {
  //           setAgencies(res.data);

  //           const oldestAgency = F.getOldestAgency(res.data);

  //           const start = moment(oldestAgency.start_date).format("YYYY-MM-DD");
  //           const end = moment().format("YYYY-MM-DD");

  //           setStartDate(start);
  //           setEndDate(end);
  //         }
  //       } catch (err) {
  //         console.error(err);
  //       }
  //     } else {
  //       const { start_date, end_date } = F.getDefaultDateRange();
  //       setStartDate(AMDashboardFilter.datemodified.start_date || start_date);
  //       setStartDate(AMDashboardFilter.datemodified.end_date || end_date)
  //     }
  //   };

  //   initDates();
  // }, []);



  useEffect(() => {
    if (agency_id) return;
    let agencyId = "";
    let user = useBoundStore.getState().userInfo;
    if (!user) {
      axios.get("/api/user").then((res) => {
        if (
          res.data.user_agency_assoc &&
          res.data.user_agency_assoc.length > 0
        ) {
          agencyId = res.data.user_agency_assoc[0].agency_id || null;
        }
        setAgencyId(agencyId);
      });
    }
    if (user.user_type == AGENCY_MANAGER) {
      fetchAssociatedAgencies();
    }
  }, []);

  useEffect(() => {
    axios.get("/api/get_active_associations").then((res) => {
      let lsp = [];
      res.data.forEach((e) => {
        lsp.push({
          text: e.first_name + " " + e.last_name,
          value: e.first_name + " " + e.last_name,
          name: e.first_name + " " + e.last_name,
          id: e.id,
          user_type: e.user_type,
        });
      });
      setAgencyStaffList(lsp);
      setLsp(lsp);
    });
  }, []);


  // commented due to old date filter implementation
  // useEffect(() => {
  //   loadAppointmentLogs();
  // },
  //   // [agency_id, start_date, end_date, searchFilter]
  //   [agency_id, searchFilter]
  // );

  const selectAgency = (value) => {
    let startDate = start_date;
    let endDate = end_date;
    if (isGlobalDashboard) {
      startDate = GLOBAL_DASHBOARD_START_DATE;
      endDate = GLOBAL_DASHBOARD_END_DATE;
      setStartDate(startDate);
      setEndDate(endDate);
    } else if (value) {
      const selected = agencies.find(a => a.agency_id === value);
      if (selected) {
        startDate = moment(selected.start_date).format("YYYY-MM-DD");
        endDate = moment().format("YYYY-MM-DD");
        setStartDate(startDate);
        setEndDate(endDate);
      }
    }

    setSelectedAgency(value);
    value = !value ? ALL_AGENCIES : value;
    getHistoryGrid({ agency_id: value, from: startDate, end: endDate });
  };

  const fetchAssociatedAgencies = async () => {
    try {
      const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${user.id}`);
      if (res.data && res.data.length > 0) {
        setAgencies(res.data);
        const oldestAgency = F.getOldestAgency(res.data);
        setStartDate(moment(oldestAgency.start_date).format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
      }
    } catch (error) {
      console.error("Error fetching associated agencies:", error);
    }
    return null;
  };


  const onRangeChange = (dates) => {

    let start_date = dates && dates[0]
      ? moment(dates[0]).format("YYYY-MM-DD")
      : null;

    let end_date = dates && dates[1]
      ? moment(dates[1]).format("YYYY-MM-DD")
      : null;

    if (start_date && end_date) {
      getHistoryGrid({ start_date, end_date })
    }

  };

  const getHistoryGrid = async ({
    from = start_date,
    to = end_date,
    agency_id,
    search,
    page = 1,
    typeOfCall,
    staffUserType = user_type,
    isExport = false
  }) => {
    const apiUrl =
      user.user_type === SUPER_ADMIN
        ? GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID
        : user.user_type == AGENCY_MANAGER
        ? GET_AM_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID
        : GET_AO_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID;
    let agencyId = agency_id || selectedAgency;
    agencyId = agencyId == ALL_AGENCIES ? "" : agencyId;
    try {
      const promises = type_of_call.map(async (call_type) => {
        if (user.user_type === SUPER_ADMIN) {
          const payload = {
            agency_ids: getGlobalDashboardAgencyIdsForHistory(),
            start_date: from,
            end_date: to,
            page,
            type_of_call: call_type,
            ...(search ? { search } : {}),
            ...((staffUserType && staffUserType != 'all') ? { bfile_user_id: staffUserType } : {}),
            ...(isExport ? { export: true } : {}),
          };

          const response = await axios.post(
            apiUrl,
            payload,
            isExport ? { responseType: "blob" } : undefined,
          );

          if (isExport && (call_type == type_of_call_selected)) {
            if (response.data.type === "application/json") {
              message.error("No data found");
              return;
            }

            const blob = new Blob([response.data], {
              type: "text/csv;charset=utf-8;"
            });
            const fileName = `${F.transformCallTypeLabel(type_of_call_selected)} Report_${moment().format("YYYY-MM-DD")}.csv`;
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = downloadUrl;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            return;
          }

          return { call_type, response };
        }

        const params = {
          start_date: from,
          end_date: to,
          ...(call_type && call_type !== "null"
            ? { type_of_call: call_type }
            : {}),
          ...(agencyId ? { agency_id: agencyId } : {}),
          ...(search ? { search: search } : {}),
          // ...(user_t ? { bfile_user_id: user_t } : {}),
          ...((staffUserType && staffUserType != 'all') ? { bfile_user_id: staffUserType } : {}),
          ...(isExport ? { export: true } : {}),
          page,
        };

        const queryString = new URLSearchParams(params).toString();
        const url = `${apiUrl}?${queryString}`;
        let response;

        if (isExport) {
          response = await axios.get(url, {
            responseType: "blob"
          });
        } else {
          response = await axios.get(url);
        }

        //  EXPORT FLOW
        if (isExport && (call_type == type_of_call_selected)) {
          if (response.data.type === "application/json") {
            message.error("No data found");
            return;
          }

          const blob = new Blob([response.data], {
            type: "text/csv;charset=utf-8;"
          });

          const fileName = `${F.transformCallTypeLabel(type_of_call_selected)} Report_${moment().format("YYYY-MM-DD")}.csv`;

          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");

          link.href = downloadUrl;
          link.setAttribute("download", fileName);

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          window.URL.revokeObjectURL(downloadUrl);

          return;
        }



        return { call_type, response };
      });





      const results = await Promise.all(promises);

      if (isExport) {
        return;
      }

      const getResult = (callType) => results.find((result) => result && result.call_type === callType);

      let bfiles = {
        Review: {
          data: (getResult("Review") && getResult("Review").response.data.data) || [],
          page: (getResult("Review") && getResult("Review").response.data.page) || 1,
          total_pages: (getResult("Review") && getResult("Review").response.data.total_pages) || 0,
        },
        FollowUp: {
          data: (getResult("FollowUp") && getResult("FollowUp").response.data.data) || [],
          page: (getResult("FollowUp") && getResult("FollowUp").response.data.page) || 1,
          total_pages: (getResult("FollowUp") && getResult("FollowUp").response.data.total_pages) || 0,
        },
        Prospect: {
          data: (getResult("Prospect") && getResult("Prospect").response.data.data) || [],
          page: (getResult("Prospect") && getResult("Prospect").response.data.page) || 1,
          total_pages: (getResult("Prospect") && getResult("Prospect").response.data.total_pages) || 0,
        },
      };

      setBfiles(bfiles);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadAppointmentLogs = async (page = 1, isRefresh = false, isExport = false) => {
    setLoading(true);
    let from = start_date !== null ? `${start_date}` : null;
    let to = end_date !== null ? `${end_date}` : null;

    let direction = DESC;

    if (type_of_call_selected === "Review") {
      if ("ea_review_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_review_sorting_direction;
      }
    } else {
      if ("ea_virtual_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_virtual_sorting_direction;
      }
    }

    let agencyId;
    if (user.user_type == AGENCY_MANAGER) {
      agencyId = isRefresh ? ALL_AGENCIES : selectedAgency;
    }
    getHistoryGrid({
      from: from,
      to: to,
      search: search,
      page: page,
      agency_id: agencyId,
      isExport: isExport
    });

    // else {

    //   try {
    //     const promises = type_of_call.map(async (call_type) => {
    //       let filters = [
    //         { name: "agency_id", op: "==", val: agency_id },
    //         { name: "reschedule", op: "==", val: "0" },
    //       ];

    //       if (from !== null && to !== null) {
    //         filters.push(
    //           { name: "updated_on", op: ">=", val: `${from} 00:00:00` },
    //           { name: "updated_on", op: "<=", val: `${to} 23:59:59` }
    //         );
    //       }
    //       filters.push({ name: "type_of_call", op: "==", val: call_type });
    //       if (searchFilter !== "") filters.push(JSON.parse(searchFilter));
    //       if (user_t !== "") filters.push({ name: "bfile_user_id", op: "==", val: user_t });
    //       let url =
    //         "/api/appointment_history_details" +
    //         `?page=${page}` +
    //         '&q={"filters":' +
    //         JSON.stringify(filters) +
    //         // ',"order_by": [{ "field": "updated_on", "direction": "desc" }]}';
    //         ',"order_by": [{ "field": "updated_on", "direction":' +
    //         `"${direction}"` +
    //         "}]}";

    //       return new Promise((resolve, reject) => {
    //         axios
    //           .get(url)
    //           .then((res) => {
    //             resolve(res && res.data);
    //           })
    //           .catch((err) => reject(err));
    //       });
    //     });

    //     const [review, leads, opportunity] = await Promise.all(promises);

    //     let bfiles = {
    //       Review: {
    //         data: review.objects,
    //         page: review.page,
    //         total_pages: review.total_pages,
    //       },
    //       FollowUp: {
    //         data: opportunity.objects,
    //         page: opportunity.page,
    //         total_pages: opportunity.total_pages,
    //       },
    //       Prospect: {
    //         data: leads.objects,
    //         page: leads.page,
    //         total_pages: leads.total_pages,
    //       },
    //     };
    //     setBfiles(bfiles);
    //   } catch (e) {
    //   } finally {
    //     setLoading(false);
    //   }
    // }
  };

  const refreshStats = () => {
    let startDate, endDate;
    setSelectedAgency("");
    setSearch("");
    setSearchFilter("");

    //commented due to old date filter implementation
    // setStartDate(moment("2010-01-01").format("YYYY-MM-DD"));
    // setEndDate(moment("2050-01-01").format("YYYY-MM-DD"));

    //added due to new date filter implementation
    if (user.user_type === SUPER_ADMIN) {
      const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
      const globalDates = globalFilter.datemodified || {};
      const selectedCarriers = globalFilter.selectedCarriers || [];
      const selectedAgencyState = globalFilter.selectedAgencyState || [];
      const selectedAgencies = globalFilter.selectedAgencies && globalFilter.selectedAgencies.length > 0
        ? globalFilter.selectedAgencies
        : (globalFilter.agency_id ? [globalFilter.agency_id] : []);

      startDate = globalDates.start_date
        ? moment(globalDates.start_date).format("YYYY-MM-DD")
        : "2010-01-01";
      endDate = globalDates.end_date
        ? moment(globalDates.end_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

      set_user_type("");
      setFsFilters({
        field: "",
        direction: "",
        selectedRole: "",
        selectedAgency: "",
        searchText: "",
        filter_by_column_name: {},
      });
      applyGlobalGridAgencyFilters({
        selectedCarriers,
        selectedAgencyState,
        selectedAgencies,
        agenciesList: globalGridAgencies,
        shouldLoad: false,
      });
    } else if (user.user_type === AGENCY_MANAGER) {
      const oldest_agency = F.getOldestAgency(agencies);

      startDate = AMDashboardFilter.datemodified.start_date || oldest_agency.start_date
        ? moment(oldest_agency.start_date).format("YYYY-MM-DD")
        : "2010-01-01";

      endDate = AMDashboardFilter.datemodified.end_date || moment().format("YYYY-MM-DD");
    } else {
      const { start_date, end_date } = F.getDefaultDateRange();
      startDate = AMDashboardFilter.datemodified.start_date || start_date;
      endDate = AMDashboardFilter.datemodified.end_date || end_date;
    }

    if (isGlobalDashboard) {
      startDate = GLOBAL_DASHBOARD_START_DATE;
      endDate = GLOBAL_DASHBOARD_END_DATE;
    }

    setStartDate(startDate);
    setEndDate(endDate);


    if (user.user_type !== SUPER_ADMIN) {
      set_user_type(localStorage.getItem("user_t") || "");
    }
    localStorage.removeItem("agGridColumnState");

    if (columnApi) {
      columnApi.resetColumnState();
      columnApi.resetColumnGroupState();
    }
    getHistoryGrid({
      from: startDate,
      to: endDate,
      page: 1,
      staffUserType: user.user_type === SUPER_ADMIN ? "" : user_type,
    });
  };

  const handleExportExcel = () => {
    getHistoryGrid({ isExport: true });
  }

  const onChangeDate = (date, type) => {
    date = (date && moment(date).format("YYYY-MM-DD")) || null;
    if (type === "start_date") setStartDate(date);
    if (type === "end_date") setEndDate(date);
  };

  const searchChange = (val) => {
    const searchPurify = F.removeSpecialCharactersFromString(val);
    const searchArr = [...new Set(searchPurify.trim().split(" "))];
    let filters = "";

    if (searchPurify !== "") {
      const queries = [];
      searchArr.forEach((item) => {
        queries.push({
          name: "first_name",
          op: "like",
          val: encodeURIComponent("%" + item + "%"),
        });
        queries.push({
          name: "last_name",
          op: "like",
          val: encodeURIComponent("%" + item + "%"),
        });
      });
      filters = '{"or":' + JSON.stringify(queries) + "}";
    }
    setSearch(val);
    setSearchFilter(filters);
  };

  let direction = DESC;

  if (type_of_call_selected === "Review") {
    if ("ea_review_sorting_direction" in window.localStorage) {
      direction = window.localStorage.ea_review_sorting_direction;
    }
  } else {
    if ("ea_virtual_sorting_direction" in window.localStorage) {
      direction = window.localStorage.ea_virtual_sorting_direction;
    }
  }

  // Convert AntD columns to Ag Grid columnDefs
  const columnDefs = [
    {
      headerClass: "custom-ag-header",
      headerName: "Customer Name",
      field: "customer_name",
      minWidth: 150,
      flex: 1,
      sortable: false,
      headerComponent: CustomHeader,
      headerComponentParams: (params) => ({
        headers: ["Customer Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "customer_name",
      }),
      filter: "agTextColumnFilter",
      cellRendererFramework: (params) => params.value,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Calendar Time",
      field: "calendar_time",
      minWidth: 150,
      flex: 1,
      sortable: false,
      headerComponent: CustomHeader,
      headerComponentParams: (params) => ({
        headers: ["Calendar Time"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "calendar_time",
      }),
      filter: "agTextColumnFilter",
      cellRendererFramework: (params) => <div>{params.value}</div>,
    },
    {
      headerClass: "custom-ag-header",
      headerName: "Agency Staff",
      field: "lsp",
      minWidth: 150,
      flex: 1,
      sortable: false,
      headerComponent: CustomHeader,
      headerComponentParams: (params) => ({
        headers: ["Agency Staff"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "lsp",
      }),
      filter: "agTextColumnFilter",
      cellRendererFramework: (params) => <div>{params.value}</div>,
    },
    // Uncomment and adapt if you want to add Status column
    // {
    //   headerClass: 'custom-ag-header',
    //   headerName: 'Status',
    //   field: 'status',
    //   minWidth: 150,
    //   flex: 1,
    //   headerComponent: CustomHeader,
    //   headerComponentParams: (params) => ({
    //     headers: ['Status'],
    //     colDef: params.column.getColDef(),
    //     columnApi: params.columnApi,
    //     field: 'status',
    //   }),
    //   filter: 'agTextColumnFilter',
    //   cellRendererFramework: (params) => (
    //     <div>
    //       <span className="dot" style={{ backgroundColor: params.data.borderBottomColor }}></span>{' '}
    //       <span>{params.value}</span>
    //     </div>
    //   ),
    // },
  ];

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);

    // restore saved column state if present
    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }, []);

  const saveState = useCallback((params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }, []);

  let data = [];
  if (bfiles[type_of_call_selected]["data"].length !== 0) {
    for (let i = 0; i < bfiles[type_of_call_selected]["data"].length; i++) {
      const bfile_data = bfiles[type_of_call_selected]["data"][i];
      let calendar_time = moment(bfile_data.appointment_date).format(
        "MM/DD/YYYY hh:mmA"
      );
      // if (user.user_type === AGENCY_MANAGER) {
      calendar_time =
        type_of_call_selected === "Review"
          ? moment(bfile_data.rs_appointment_date).format("MM/DD/YYYY hh:mmA")
          : moment(F.getVonBorderAppointmentDateFromBFile(bfile_data)).format(
            "MM/DD/YYYY hh:mmA"
          );
      // }
      let isComplete = null;
      if (type_of_call_selected === "Review") {
        // isComplete = bfile_data.need_attention ||
        //   bfile_data.onboarding_id ||
        //   bfile_data.financial_id ||
        //   bfile_data.is_onboarded ||
        //   bfile_data.archive ||
        //   bfile_data.bfile_folow_up_completed
        isComplete = bfile_data.bfile_review_completed;
      } else {
        isComplete = F.isVonBorderBFileCompleted(bfile_data);
      }

      const status = isComplete ? "Complete" : "Not Complete";

      // for dot color of status
      let borderBottomColor = "#2dcc70";
      if (!isComplete) {
        // compare appointment time with current time => http://jsfiddle.net/e34y0p1v/
        var currentDateTime = moment(new Date()).utc(); // 09
        var appointmentDate =
          type_of_call_selected === "Review"
            ? moment(new Date(bfile_data.rs_appointment_date)).utc()
            : moment(
              new Date(F.getVonBorderAppointmentDateFromBFile(bfile_data))
            ).utc(); // 08
        var diffInHours = appointmentDate.diff(currentDateTime, "hours");

        // TRUE => UPCOMING , FALSE => TIME EXCEEDED
        const isUpcomingAppointment = diffInHours >= -12;

        if (isUpcomingAppointment) borderBottomColor = "#f1c40f";
        else borderBottomColor = "#e74c3d";
      }

      data.push({
        id: i,
        customer_name: (
          // <Tooltip placement="right" title={bfile_data.first_name + " " + bfile_data.last_name}>
          <Link to={"/customer/" + bfile_data.id}>
            {`${bfile_data.first_name} ${bfile_data.last_name}`}
          </Link>
          // </Tooltip>
        ),
        calendar_time: calendar_time || "-",
        lsp:
          user.user_type === AGENCY_MANAGER
            ? ((bfile_data &&
              bfile_data.bfile &&
              bfile_data.bfile.user &&
              bfile_data.bfile.user.first_name) ||
              "-") +
            " " +
            ((bfile_data &&
              bfile_data.bfile &&
              bfile_data.bfile.user &&
              bfile_data.bfile.user.last_name) ||
              "-")
            : ((bfile_data &&
              bfile_data.bfile &&
              bfile_data.bfile.user &&
              bfile_data.bfile.user.first_name) ||
              "-") +
            " " +
            ((bfile_data &&
              bfile_data.bfile &&
              bfile_data.bfile.user &&
              bfile_data.bfile.user.last_name) ||
              "-"),
        status,
        borderBottomColor,
      });
    }
  }

  const selectGlobalGridAgencies = (selectedAgencies) => {
    applyGlobalGridAgencyFilters({
      selectedAgencies,
      shouldLoad: true,
    });
  };

  const searchGlobalGridAgencies = (value) => {
    if (!value) {
      setGlobalGridAgencyOptions(getInitialGlobalAgencyOptions(
        globalGridFilteredAgencyResults,
        gridSelectedAgencies,
      ));
      return;
    }

    const lower = value.toLowerCase();
    const filtered = globalGridFilteredAgencyResults.filter((agency) =>
      (agency.name || `Agency #${agency.id}`).toLowerCase().includes(lower)
    );
    setGlobalGridAgencyOptions(filtered);
  };

  const renderGlobalGridFilters = () => {
    if (user.user_type !== SUPER_ADMIN) return null;

    const filterSelectStyle = {
      minWidth: 170,
      maxWidth: 220,
      fontSize: "12px",
    };

    return (
      <div className="ealogs-global-grid-filters">
        <Select
          mode="multiple"
          placeholder="Select Carrier"
          getPopupContainer={(trigger) => {
            return trigger.parentElement;
          }}
          maxTagCount={1}
          maxTagTextLength={16}
          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
          allowClear
          showSearch
          className="custom-select agency-select"
          style={filterSelectStyle}
          value={gridSelectedCarriers}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={(value) => {
            applyGlobalGridAgencyFilters({
              selectedCarriers: value,
              selectedAgencies: [],
            });
          }}
          dropdownRender={(menu) => (
            <div>
              <div
                className="ealogs-select-all-option"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  const allIds = F.getCarriers().map((carrier) => carrier.id);
                  const isAllSelected = gridSelectedCarriers.length === allIds.length;
                  applyGlobalGridAgencyFilters({
                    selectedCarriers: isAllSelected ? [] : allIds,
                    selectedAgencies: [],
                  });
                }}
              >
                <Checkbox
                  checked={gridSelectedCarriers.length === F.getCarriers().length}
                  indeterminate={
                    gridSelectedCarriers.length > 0 &&
                    gridSelectedCarriers.length < F.getCarriers().length
                  }
                >
                  Select All
                </Checkbox>
              </div>
              {menu}
            </div>
          )}
        >
          {F.getCarriers().map((carrier) => (
            <Option key={carrier.id} value={carrier.id}>
              {carrier.name}
            </Option>
          ))}
        </Select>

        <Select
          mode="multiple"
          placeholder="Select Agency Status"
          getPopupContainer={(trigger) => {
            return trigger.parentElement;
          }}
          maxTagCount={1}
          maxTagTextLength={16}
          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
          allowClear
          showSearch
          className="custom-select agency-select"
          style={{ ...filterSelectStyle, minWidth: 175 }}
          value={gridSelectedAgencyState.map(String)}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={(value) => {
            applyGlobalGridAgencyFilters({
              selectedAgencyState: value,
              selectedAgencies: [],
            });
          }}
          dropdownRender={(menu) => (
            <div>
              <div
                className="ealogs-select-all-option"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  const allIds = F.getAgenciesState().map((agencyState) => String(agencyState.id));
                  const isAllSelected = gridSelectedAgencyState.length === allIds.length;
                  applyGlobalGridAgencyFilters({
                    selectedAgencyState: isAllSelected ? [] : allIds,
                    selectedAgencies: [],
                  });
                }}
              >
                <Checkbox
                  checked={gridSelectedAgencyState.length === F.getAgenciesState().length}
                  indeterminate={
                    gridSelectedAgencyState.length > 0 &&
                    gridSelectedAgencyState.length < F.getAgenciesState().length
                  }
                >
                  Select All
                </Checkbox>
              </div>
              {menu}
            </div>
          )}
        >
          {F.getAgenciesState().map((agencyState) => (
            <Option key={String(agencyState.id)} value={String(agencyState.id)}>
              {agencyState.name}
            </Option>
          ))}
        </Select>

        <Select
          mode="multiple"
          placeholder="Select Agency"
          getPopupContainer={(trigger) => {
            return trigger.parentElement;
          }}
          maxTagCount={1}
          maxTagTextLength={16}
          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
          allowClear
          showSearch
          filterOption={false}
          className="custom-select agency-select"
          style={{ ...filterSelectStyle, minWidth: 220 }}
          value={gridSelectedAgencies}
          onSearch={searchGlobalGridAgencies}
          onChange={selectGlobalGridAgencies}
          dropdownRender={(menu) => (
            <div>
              <div
                className="ealogs-select-all-option"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  const allIds = globalGridAgencyOptions.map((agency) => agency.id);
                  const isAllSelected =
                    gridSelectedAgencies.length === allIds.length && allIds.length > 0;
                  selectGlobalGridAgencies(isAllSelected ? [] : allIds);
                }}
              >
                <Checkbox
                  checked={
                    gridSelectedAgencies.length === globalGridAgencyOptions.length &&
                    globalGridAgencyOptions.length > 0
                  }
                  indeterminate={
                    gridSelectedAgencies.length > 0 &&
                    gridSelectedAgencies.length < globalGridAgencyOptions.length
                  }
                >
                  Select All
                </Checkbox>
              </div>
              {menu}
            </div>
          )}
        >
          {globalGridAgencyOptions.map((agencyOption) => (
            <Option key={agencyOption.id} value={agencyOption.id}>
              {agencyOption.name || `Agency #${agencyOption.id}`}
            </Option>
          ))}
        </Select>
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: "white", padding: "20px" }}>
      <div className="header-vaa-history">
        <div className="left-align-vaa-history">
          <div>
            <Icon type="folder" style={{ marginRight: 10, color: "#1890ff" }} />
            <b>
              <Translate text={"B File Appointment History Details"} />
            </b>
          </div>
          <Translator>
            {({ translate }) => (
              <Input
                className="layoutsearch input-ellipse"
                prefix={<Icon type="search" style={{ color: "gray" }} />}
                value={search}
                allowClear
                placeholder={translate({ text: `Search File` })}
                style={{ width: "60%", marginTop: 10 }}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearch(value);
                  if (!value) {
                    searchChange("");
                  }
                }}
                onPressEnter={(e) => searchChange(e.target.value)}
              />
            )}
          </Translator>
        </div>
        <div className="right-align-side-vaa-history">
          <div className="datepicker-container">
            {/* Agency Dropdown */}
            <div className="agency-dropdown-container">
              {user.user_type === AGENCY_MANAGER && (
                <Select
                  allowClear
                  showSearch
                  className="custom-select history-select"
                  style={{
                    fontSize: "12px",
                    backgroundColor: "white",
                    borderRadius: "20px",
                    width: "200px",
                    marginTop: "20px",
                    alignItems: "end",
                  }}
                  placeholder="Search By Agency"
                  optionFilterProp="children"
                  onChange={selectAgency}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={selectedAgency}
                >
                  <Option value="" style={{ fontSize: "12px" }}>
                    All Agencies
                  </Option>
                  {agencies.map((opt) => (
                    <Option
                      key={opt.agency_id}
                      value={opt.agency_id}
                      style={{ fontSize: "12px" }}
                    >
                      {opt.agency_name}
                    </Option>
                  ))}
                </Select>
              )}
            </div>

            {/* Date Pickers and Refresh Button */}
            <div
              className="datepicker"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >

              {
                (user.user_type == EA || user.user_type == LSP) && (
                  <Select
                    className="dropDown custom-select"
                    style={{ width: "220px !important", marginTop: "20px", }}
                    value={user_type && user_type !== "" ? user_type : "all"}
                    // value={user_t !== undefined ? user_t : undefined}
                    placeholder="Select Staff"
                    allowClear
                    onChange={(value) => {
                      set_user_type(value);
                    }}
                  >
                    <Select.Option value="all">
                      All
                    </Select.Option>

                    {agencyStaffList.map((e) => (
                      <Select.Option key={e.id} value={String(e.id)}>
                        {e.name}
                      </Select.Option>
                    ))}
                  </Select>
                )
              }


              <Col className="date-picker-col">
                <div className='datepicker-label' style={{ fontSize: 'x-small' }}>
                  Select Date Range</div>
                <DatePicker.RangePicker
                  dropdownClassName="custom-range-picker" //for header
                  open={open}
                  // onOpenChange={(status) => setOpen(status)}
                  onOpenChange={(status) => {
                    if (!status) return;
                    setOpen(true);
                  }}
                  value={[
                    start_date ? moment(start_date) : null,
                    end_date ? moment(end_date) : null
                  ]}
                  format={dateFormat}
                  // onChange={(dates) => onRangeChange(dates)}
                  onChange={(dates) => {
                    if (dates && dates.length === 2) {
                      const start = dates[0].format("YYYY-MM-DD");
                      const end = dates[1].format("YYYY-MM-DD");

                      setStartDate(start);
                      setEndDate(end);

                    }
                  }}
                  renderExtraFooter={() => {
                    const start = start_date
                      ? moment(start_date)
                      : moment();

                    const end = end_date
                      ? moment(end_date)
                      : moment();

                    return (
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between', gap: 20
                      }}>

                        {/* START CONTROLS */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                          <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                          <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                            <Select
                              showSearch
                              value={start.month()}
                              style={{ width: 100 }}
                              // className="dateRangedropDown custom-select"
                              onChange={(month) => {
                                const newDate = start.clone().month(month);
                                setStartDate(newDate.format("YYYY-MM-DD"));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {months.map((m, i) => (
                                <Option key={i} value={i}>{m}</Option>
                              ))}
                            </Select>

                            <Select
                              showSearch
                              value={start.year()}
                              // className="dateRangedropDown custom-select"
                              style={{ width: 80 }}
                              onChange={(year) => {
                                const newDate = start.clone().year(year);
                                setStartDate(newDate.format("YYYY-MM-DD"));

                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {years.map((y) => (
                                <Option key={y} value={y}>{y}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>

                        {/* END CONTROLS */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                          <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                          <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                            <Select
                              showSearch
                              value={end.month()}
                              style={{ width: 100 }}
                              // className="dateRangedropDown custom-select"
                              onChange={(month) => {
                                const newDate = end.clone().month(month);
                                setEndDate(newDate.format("YYYY-MM-DD"));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {months.map((m, i) => (
                                <Option key={i} value={i}>{m}</Option>
                              ))}
                            </Select>

                            <Select
                              showSearch
                              value={end.year()}
                              style={{ width: 80 }}
                              // className="dateRangedropDown custom-select"
                              onChange={(year) => {
                                const newDate = end.clone().year(year);
                                setEndDate(newDate.format("YYYY-MM-DD"));
                              }}
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              {years.map((y) => (
                                <Option key={y} value={y}>{y}</Option>
                              ))}
                            </Select>
                          </div>
                        </div>

                        {/* TODAY BUTTON */}
                        <div
                          style={{
                            alignSelf: 'center', cursor: 'pointer',
                            color: '#1890ff',
                            marginTop: '10px'
                          }}
                          onClick={() => {
                            const today = moment().format("YYYY-MM-DD");

                            setStartDate(today);
                            setEndDate(today);

                            getHistoryGrid({
                              from: today,
                              to: today,
                            });

                            // setOpen(false);
                          }}
                        >
                          Today
                        </div>

                        {/* VIEW BUTTON */}

                        <div
                          style={{
                            alignSelf: 'center'
                          }}>
                          <Button type="primary"
                            className="borderRadius-28 bg-164897"
                            style={{ marginTop: '15px' }}
                            onClick={() => {
                              getHistoryGrid({
                                from: start_date,
                                to: end_date,
                              });

                              setOpen(false);
                            }}
                          >
                            <Translate text={"Apply"}></Translate>
                          </Button>
                        </div>
                      </div>
                    );
                  }}
                />
              </Col>



              {/* <div className="datePicker-width-container">
                <div className="datepicker-label">Start Date</div>
                <DatePicker
                  value={(start_date && moment(start_date)) || null}
                  format={dateFormat}
                  onChange={(e) => onChangeDate(e, "start_date")}
                />
              </div>
              <div className="datePicker-width-container">
                <div className="datepicker-label">End Date</div>
                <DatePicker
                  value={(end_date && moment(end_date)) || null}
                  format={dateFormat}
                  onChange={(e) => onChangeDate(e, "end_date")}
                />
              </div> */}
              {user.user_type !== SUPER_ADMIN && (
                <div>
                  <Button
                    type='primary'
                    className='borderRadius-28 bg-164897'
                    style={{ marginTop: "22px" }}
                    onClick={() => handleExportExcel()}
                  >
                    <Icon type="upload" style={{ marginRight: '10px' }} />
                    <Translate text={EXPORT_DATA} />
                  </Button>
                </div>
              )}
              <div>
                <Button
                  type="primary"
                  className="refresh-con"
                  onClick={() => refreshStats()}
                  style={{ marginTop: "22px" }}
                >
                  <Icon type="reload" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {user.user_type === SUPER_ADMIN && (
        <div className="ealogs-filter-row">
          {renderGlobalGridFilters()}
        </div>
      )}
      <Row>
        <ButtonGroup className="button_selection_group bfile">

          {reviewEaDash == 1 && (
            <Button
              className={
                type_of_call_selected === "Review"
                  ? "Review active"
                  : "inactive"
              }
              onClick={() => setSelectedCallType("Review")}
            >
              Review Appointments
            </Button>
          )}

          {leadEaDash == 1 && (
            <Button
              className={
                type_of_call_selected === "Prospect"
                  ? "leads active"
                  : "inactive"
              }
              onClick={() => setSelectedCallType("Prospect")}
            >
              Lead Appointments
            </Button>
          )}

          {opportunityEaDash == 1 && (
            <Button
              className={
                type_of_call_selected === "FollowUp"
                  ? "Opportunities active"
                  : "inactive"
              }
              onClick={() => setSelectedCallType("FollowUp")}
            >
              Opportunity Appointments
            </Button>
          )}

        </ButtonGroup>

      </Row>
      <Row>
        <Spin indicator={antIcon} spinning={loading}>
          <div style={{ marginBottom: 20 }}>
            <Card bordered={false} className="statsDetails have_extra">
              <CustomAgGridTable
                rowDatas={data || []}
                onGridReady={onGridReady}
                onColumnMoved={saveState}
                onSortChanged={saveState}
                onFilterChanged={saveState}
                columnDefss={columnDefs}
              />
              <Pagination
                current_page={bfiles[type_of_call_selected].page}
                total_pages={bfiles[type_of_call_selected].total_pages}
                onClick={(page) => {
                  loadAppointmentLogs(page);
                }}
              />
            </Card>
          </div>
        </Spin>
      </Row>
    </div>
  );
}

export default EaAppointmentLogs;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/EaAppointmentLogs.js